import imoValidator from "./Misc/imoValidator";

const ValidationHelper = {

	isValidIMO: (imo, verbose = false) => {
		return imoValidator(imo, verbose);
	},
	isValidMMSI: (mmsi) => {
		const regex = new RegExp("^[0-9]{9}$");
		return regex.test(mmsi);
	},
	isValidICAO: (icao) => {
		// TODO: What are the rules to validate this?
		return icao.length === 6; // "4072EA"
	},

	isValidNonZeroNumber: (num, fieldName = "Number") => {
		if (Number.isNaN(num)) {
			throw new Error(fieldName + " is invalid (nan)");
		}
		else if (!Number.isFinite(num)) {
			throw new Error(fieldName + " is invalid (infinity)");
		}
		else if (num === 0) {
			throw new Error(fieldName + " is invalid (it should not be 0)");
		}
		return true;
	},

	validateUsername: (username) => {
		const array = [];
		return array;
	},

	validateEmailAddress: (emailAddress) => {
		const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const result = pattern.test(emailAddress);
		const array = [];
		if (!result) {
			array.push("Invalid email address");
		}
		return array;
	},

	validateNewPassword: (password) => {
		const array = [];

		if (password.length < 8) {
			array.push("Password must contain at least 8 characters.");
		}

		const lowercases = "abcdefghijklmnopqrstuvwxyz";
		const uppercases = lowercases.toUpperCase();
		const numbers = "0123456789";
		const specials = "!@£$%^&*()_+#-=[]{};:,./<>?`~\\|'\"";

		let foundLowercase = false;
		let foundUppercase = false;
		let foundNumber = false;
		let foundSpecial = false;
		for (let i = 0; i < password.length; i++) {
			const char = password[i];
			if (lowercases.indexOf(char) >= 0) {
				foundLowercase = true;
			}
			if (uppercases.indexOf(char) >= 0) {
				foundUppercase = true;
			}
			if (numbers.indexOf(char) >= 0) {
				foundNumber = true;
			}
			if (specials.indexOf(char) >= 0) {
				foundSpecial = true;
			}
		}
		if (!foundLowercase) {
			array.push("Password must contain a lower case letter.");
		}
		if (!foundUppercase) {
			array.push("Password must contain an upper case letter.");
		}
		if (!foundSpecial) {
			array.push("Password must contain a special character.");
		}
		if (!foundNumber) {
			array.push("Password must contain a number.");
		}
		return array;
	}
};
export default ValidationHelper;
